import type { StorePurchaseVerificationInput } from "@/integrations/billing/storeEntitlements";

type NativeStoreBridge = {
  syncLatestPurchase: () => Promise<StorePurchaseVerificationInput>;
  restorePurchases: () => Promise<StorePurchaseVerificationInput[]>;
};

declare global {
  interface Window {
    InvestmentPropertyMateStoreBridge?: NativeStoreBridge;
  }
}

const getBridge = (): NativeStoreBridge | null =>
  typeof window === "undefined" ? null : window.InvestmentPropertyMateStoreBridge ?? null;

export const ensureNativeStoreBridge = (): NativeStoreBridge => {
  const bridge = getBridge();
  if (!bridge) {
    throw new Error(
      "Native purchase bridge is unavailable in this build. Use the iOS/Android app build with store billing enabled."
    );
  }
  return bridge;
};

export const syncLatestNativePurchase = async (): Promise<StorePurchaseVerificationInput> =>
  ensureNativeStoreBridge().syncLatestPurchase();

export const restoreNativePurchases = async (): Promise<StorePurchaseVerificationInput[]> =>
  ensureNativeStoreBridge().restorePurchases();
